import { UserRoundCheck } from 'lucide-react';
import { essGet } from '../../api/api';
import LiveDashboardPage from './LiveDashboardPage';

export default function ESSDashboardPage() {
  return <LiveDashboardPage title="ESS" description="Employee Self Service" icon={UserRoundCheck} getData={essGet} intro="" />;
}